var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUserDetails = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 13.6001,
    width: 19,
    height: 3.39993,
    rx: 1.69996,
    fill: "#323A45"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 6.80005,
    width: 19,
    height: 3.39993,
    rx: 1.69996,
    fill: "#323A45"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 3.39993,
    rx: 1.69996,
    fill: "#323A45"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserDetails);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user-details.bcb5665d287942137fa825135062ba92.svg";